<template>
  <div class="defaultSeat" :style="{backgroundImage:`url(${chartData.defaultImg})`}">
    <div class="error-description">当前图表无数据</div>
  </div>
</template>

<script>

export default {
  name: "defaultSeat",
  props: {
    chartData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  }
}
</script>

<style scoped lang="less">
.defaultSeat {
  width: 100%;
  height: 100%;
  display:flex;
  align-items: center;
  justify-content: center;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: 50%;
  background-color: #fff;
  .error-description{
    min-width: 185px;
    background: #fff;
    border: 1px solid rgba(0,0,0,.06);
    height: 34px;
    opacity: .8;
    display: flex;
    align-items: center;
    justify-content: center;
    color: rgba(0,0,0,.5);
    max-width: 80%;
    margin-top: 10px;
    text-align: center;
  }
}
</style>
